import type { ReactNode } from "react";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface UsageDetailsSectionProps {
  children: ReactNode;
  showMenu?: boolean;
  title: string;
}

export const UsageDetailsSection = ({
  title,
  children,
  showMenu = false,
}: UsageDetailsSectionProps) => (
  <div className="border-primary -mx-6 flex flex-col gap-y-5 px-6 pb-6 [&:not(:last-child)]:border-b">
    <div className="flex items-center justify-between">
      <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
      {showMenu && (
        <div className="flex justify-end">
          <Icon type="menu-dots" />
        </div>
      )}
    </div>
    {children}
  </div>
);
